import React, {useContext} from 'react';
import {Props} from '@src/components/Form/FormField';
import {ITechOperationModel} from '@src/@interfaces/models/TechOperation/ITechOperationModel';
import {FormFieldDesignContext} from '@src/contexts/FormFieldDesignContext';
import {Controller, useFormContext} from 'react-hook-form';
import {IClientModel} from '@src/@interfaces/models/Client/IClientModel';
import CustomSelect from '@src/components/Fields/CustomSelect';
import classnames from '@src/helpers/classnames';
import {FormFieldConfigSize, FormFieldOption} from '@src/@types/components/Form';
import FormErrorMessage from '@src/components/Form/FormErrorMessage';

const emptyArray: never[] = [];

export default function TechOperationSelect(props: Props<ITechOperationModel> & { options?: FormFieldOption[] | null }) {
    const [design] = useContext(FormFieldDesignContext);
    const {control} = useFormContext<IClientModel>();

    const isDisabled = props.forceDisabled || design.fieldsAreDisabled || design.fieldsAreReadOnly;

    return <>
        <Controller
                control={control}
                name={props.fieldName}
                render={({field: {name, value, onChange, onBlur}, fieldState: {error}}) => {
                    return <CustomSelect<true>
                            label={props.config.label}
                            className={classnames({
                                'is-invalid': Boolean(error)
                            })}
                            name={name}
                            size={design.size as FormFieldConfigSize}
                            options={props.options ?? emptyArray}
                            readOnly={isDisabled || design.fieldsAreReadOnly}
                            disabled={isDisabled || design.fieldsAreDisabled}
                            value={value}
                            onChange={onChange}
                            onBlur={onBlur}
                            menuPortalTarget={document.body}
                            multiple
                    />;
                }}
        />

        <FormErrorMessage fieldName={props.fieldName}/>
    </>;
}
